import React from "react";

function UNNumberList({
  selectedUNNumber,
  lastIndexMap,
  unSource,
  handleUNLinkClick,
  removeUNNumber,
  handleAddUNClick,
  inlineStyle=false,
  isEditMode=true
}) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: inlineStyle ? "row" : "column",
        gap: 4,
        marginBottom: 8,
      }}
    >
      {selectedUNNumber.map((val, index) => {
        const entry = typeof val === "string" ? { un_number: val } : val;

        // Only render the last occurrence of each un_number
        if (lastIndexMap.get(entry.un_number) !== index) {
          return null;
        }

        const un = unSource.find((u) => u.un_number === entry.un_number);

        if (!un) return null;

        return (
          <div
            key={`${un.un_number}-${index}`}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <button
              type="button"
              style={{
                background: "none",
                border: "none",
                padding: 0,
                font: "inherit",
                color: "#576ec1",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={() => handleUNLinkClick(index)}
            >
              {un.un_number}
            </button>

            {isEditMode && <span
              style={{
                color: "#f5222d",
                cursor: "pointer",
                fontSize: 12,
              }}
              onClick={() => removeUNNumber(index)}
            >
              ✕
            </span>}
          </div>
        );
      })}

    {isEditMode &&  <div style={{display: "flex", alignItems: "center", gap: 8, padding: 5}}>
        <button
          type="button"
          onClick={handleAddUNClick}
          style={{
            background: "none",
            border: "none",
            padding: 0,
            margin: 0,
            color: "#576ec1",
            cursor: "pointer",
            fontSize: 13,
          }}
        >
          + Add UN Number
        </button>
      </div>}
    </div>
  );
}

export default UNNumberList;